// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__QRua6","container":"styles_container__1T_uv","infoSection":"styles_infoSection__2D-DM"};